import { BackofficePresenter } from 'components/domain/backoffice/BackofficePresenter'
import { AppLayout } from 'components/facets'
import { useUser } from 'components/providers/UserProvider'
import { Redirect } from 'react-router-dom'

export const Backoffice = (): JSX.Element => {
  const { hasPermission } = useUser()

  if (!hasPermission('access_back_office')) {
    return <Redirect to="/" />
  }

  return (
    <AppLayout noDOMLayout>
      <BackofficePresenter />
    </AppLayout>
  )
}
